module.exports = __webpack_public_path__ + "img/icon-06.3da15e67.png";